import BillingSummary from './billing-summary.entity';
import { BillingStatus } from './billing-status.enum';

export default class Summary {
  billed: BillingSummary;

  defaulting: BillingSummary;

  notBilled: BillingSummary;

  preInvoice: BillingSummary;

  received: BillingSummary;

  toBill: BillingSummary;

  toReceive: BillingSummary;

  discounted: BillingSummary;

  withinDeadline: BillingSummary;

  billingDisabled: BillingSummary;

  billingError: BillingSummary;

  billingInProcess: BillingSummary;

  invoiceZeroValue: BillingSummary;

  invoiceHasValue: BillingSummary;

  preInvoicesWithPaymentError: BillingSummary;

  preInvoicesWithPaymentIntegrationError: BillingSummary;

  billingDisabledDetailed: BillingSummary[];

  inconsistentContractsDetailed: BillingSummary[];

  constructor(obj: any = {}) {
    this.billed = BillingSummary.of(obj.billed, BillingStatus.BILLED)
    this.defaulting = BillingSummary.of(obj.defaulting, BillingStatus.DEFAULTING)
    this.notBilled = BillingSummary.of(obj.notBilled, BillingStatus.NOT_BILLED)
    this.preInvoice = BillingSummary.of(obj.preInvoice, BillingStatus.PRE_INVOICE)
    this.received = BillingSummary.of(obj.received, BillingStatus.RECEIVED)
    this.toBill = BillingSummary.of(obj.toBill, BillingStatus.TO_BILL)
    this.toReceive = BillingSummary.of(obj.toReceive, BillingStatus.TO_RECEIVE)
    this.discounted = BillingSummary.of(obj.discounted, BillingStatus.DISCOUNTED)
    this.withinDeadline = BillingSummary.of(obj.withinDeadline, BillingStatus.WITHIN_DEADLINE)
    this.billingDisabled = BillingSummary.of(obj.billingDisabled, undefined)
    this.billingError = BillingSummary.of(obj.billingError, undefined)
    this.billingInProcess = BillingSummary.of(obj.billingInProcess, undefined)
    this.invoiceZeroValue = BillingSummary.of(obj.invoiceZeroValue,
      BillingStatus.INVOICE_ZERO_VALUE)
    this.invoiceHasValue = BillingSummary.of(obj.invoiceHasValue,
      BillingStatus.INVOICE_HAS_VALUE)
    this.preInvoicesWithPaymentError = BillingSummary.of(
      obj.preInvoicesWithPaymentError,
      BillingStatus.PRE_INVOICE_WITH_EXTERNAL_PAYMENT_ERROR,
    )
    this.preInvoicesWithPaymentIntegrationError = BillingSummary.of(
      obj.preInvoicesWithPaymentIntegrationError,
      BillingStatus.PRE_INVOICE_WITH_EXTERNAL_PAYMENT_INTEGRATION_ERROR,
    )
    this.billingDisabledDetailed = obj.billingDisabledDetailed || []
    this.inconsistentContractsDetailed = obj.inconsistentContractsDetailed || []
  }

  public static of(obj: any = {}): Summary {
    return new Summary(obj);
  }

  public static ofList(list: any[] = []): Summary[] {
    return list.map(this.of);
  }
}
